"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var EmailClickSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10,14 L4,14 C3.44771525,14 3,13.5522847 3,13 L3,6 C3,5.44771525 3.44771525,5 4,5 L14,5 C14.5522847,5 15,5.44771525 15,6 L15,10 L14,10 L14,7.55512138 L9.63323779,11.1279268 C9.26487191,11.4293171 8.73512809,11.4293171 8.36676221,11.1279268 L4,7.55512138 L4,13 L10,13 L10,14 Z M3.99666738,6.47350069 L9,10.3539695 L14.0140686,6.45847751 L14.0140686,6 L3.99666738,6 L3.99666738,6.47350069 Z M15.8792905,17.5344279 L14.9942806,18 L14.0641717,16.2319481 L12.9902803,17.1516315 C12.7385928,17.3671774 12.3598252,17.3378787 12.1442794,17.0861912 C12.0511724,16.9774725 12,16.8390495 12,16.6959109 L12,11.4693339 C12,11.1931915 12.3943787,10.7975464 12.8544062,11.1166354 L16.8656503,15.1473015 C17.0604403,15.3430347 17.002338,16 16.5112441,16 L15.0720829,16 L15.8792905,17.5344279 Z M13,15.8655137 L13.9468248,15 L15.3082481,15 L13,12.6805756 L13,15.8655137 Z" })));
};
EmailClickSmall.displayName = 'EmailClickSmall';
exports.default = EmailClickSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EmailClickSmall.js.map